import { TrendingUp } from "lucide-react";
import FinancePage from "@/components/FinancePage";

const CATEGORIES = ["Penjualan Langsung", "Jasa Tambahan", "Komisi", "Bunga Bank", "Sewa", "Donasi", "Lainnya"];

const Incomes = () => (
  <FinancePage
    title="Pemasukan Lain"
    subtitle="Catat pemasukan di luar invoice (penjualan langsung, jasa tambahan, dll)"
    endpoint="/incomes"
    categories={CATEGORIES}
    icon={TrendingUp}
    accent="success"
    totalLabel="Total Pemasukan Lain"
    enableProductPicker
  />
);

export default Incomes;
